import { size } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCredits } from '../../../redux/CreditsSlice';
import { selectPaymentData, selectUsedCredits } from '../../../redux/PaymentDataSlice';
import { selectPaymentReasons } from '../../../redux/PaymentReasonsSlice';
import { selectPortalInfo } from '../../../redux/PortalInfoSlice';
import { checkIfPaymentHasError } from '../../../utils/utilCheckIfPaymentHasError';
import PaymentSubtotalSelect from './PaymentSubtotalSelect';
import PaymentTotal from './PaymentTotal';

const PaymentSubtotal = (props) => {
  const { rows: allCredits } = useSelector(selectCredits);
  const paymentData = useSelector(selectPaymentData);
  const paymentReasons = useSelector(selectPaymentReasons);
  const portalInfo = useSelector(selectPortalInfo);
  const { usedCreditIds } = useSelector(selectUsedCredits);
  const usedCredits = allCredits.filter((c) => usedCreditIds.includes(c.id));

  const { settings: { isShortpayEnabled = false, isShortpayAdminEnabled = false, isOverpayEnabled = false } = {} } =
    portalInfo;

  const { onClick } = props;

  const { invoicesBalance = 0, subtotal = 0, paymentInvoices: invoices = [] } = paymentData;

  const credit =
    usedCredits.reduce((creditAmount, credit) => {
      return creditAmount + (credit.balance - credit.balanceLeft);
    }, 0) || 0;

  const [hasPaymentError, setHasPaymentError] = useState(false);

  useEffect(() => {
    function verifyPaymentHasError() {
      const payment = {
        invoices: paymentData.paymentInvoices,
        subtotal: paymentData.subtotal,
        hasPaymentReasons: !!size(paymentReasons),
      };
      const hasError = checkIfPaymentHasError(payment, portalInfo.settings);
      setHasPaymentError(hasError);
    }
    verifyPaymentHasError();
  }, [paymentReasons, portalInfo, paymentData, setHasPaymentError]);

  const linkTitle = size(usedCredits) > 1 ? 'View Credits' : 'View Credit';

  return (
    <>
      <div className="d-flex hui-payment-total">
        <div className="p-4 hui-bg-gray-light flex-grow-1 text-end">
          <PaymentTotal
            title="Outstanding Balance"
            amount={invoicesBalance}
            description="The outstanding balance is the sum of the unpaid invoices displayed on this page."
          />
        </div>

        <div className="p-4 hui-bg-white hui-payment-total-total">
          <PaymentSubtotalSelect
            onClick={onClick}
            //link={linkTitle}
            viewCredits={viewCredits}
            disabled={hasPaymentError}
            subtotal={subtotal}
            credit={credit}
          />
        </div>
      </div>
    </>
  );

  function viewCredits() {}
};

export default PaymentSubtotal;
